(function () {
  var styleText = [
    '.embedded .header {',
    '  padding: 16px 18px 14px !important;',
    '}',
    '.embedded .header klevu-typography {',
    '  line-height: 1.3 !important;',
    '  --klevu-typography-font-size: 16px;',
    '}',
    '.embedded .header klevu-typography,',
    '.embedded .header klevu-typography span {',
    '  color: #1c1c1c !important;',
    '  font-size: 16px !important;',
    '  font-weight: 600 !important;',
    '  line-height: 1.3 !important;',
    '}',
    '.fineprintContainer {',
    '  margin: 0 !important;',
    '  padding: 0 !important;',
    '  border-bottom: 1px solid #e6eaee !important;',
    '}',
    '.embedded .questions-container {',
    '  gap: 10px 12px !important;',
    '  padding: 16px 16px 8px !important;',
    '}',
    '.questions-container .klevu-question {',
    '  display: inline-flex !important;',
    '  align-items: center !important;',
    '  border-radius: 999px !important;',
    '  border-bottom-left-radius: 999px !important;',
    '}',
    '.questions-container svg {',
    '  fill: #3b7eb5 !important;',
    '  width: 13px;',
    '  height: 13px;',
    '  margin-right: 8px !important;',
    '  flex-shrink: 0;',
    '}',
    '.embedded div[part="product-query-popup-footer"] {',
    '  padding: 8px 16px 16px !important;',
    '}',
    '.embedded div[part="product-query-popup-footer"] .sendmessage {',
    '  gap: 8px !important;',
    '  align-items: center !important;',
    '}',
    '.disclaimer-wrapper {',
    '  display: none !important;',
    '}'
  ].join('\n');

  var buttonStyleText = [
    'button.icon,',
    'button.icon:hover,',
    'button.icon:focus,',
    'button.icon:focus-visible,',
    'button.icon:active {',
    '  border-radius: 6px !important;',
    '}',
    'button.icon:hover {',
    '  cursor: pointer !important;',
    '}',
    'button:hover::after,',
    'button:focus::after,',
    'button:focus-visible::after,',
    'button.icon:hover::after,',
    'button.icon:focus::after,',
    'button.icon:focus-visible::after {',
    '  content: none !important;',
    '  display: none !important;',
    '  border: 0 !important;',
    '}'
  ].join('\n');

  function inject(popup) {
    var root = popup.shadowRoot;
    if (!root || root.getElementById('asklo-quick-answer-style')) return;
    var style = document.createElement('style');
    style.id = 'asklo-quick-answer-style';
    style.textContent = styleText;
    root.appendChild(style);
  }

  function injectButton(buttonHost) {
    var root = buttonHost.shadowRoot;
    if (!root || root.getElementById('asklo-quick-answer-button-style')) return;
    var style = document.createElement('style');
    style.id = 'asklo-quick-answer-button-style';
    style.textContent = buttonStyleText;
    root.appendChild(style);
  }

  function styleButtons(popup) {
    var root = popup.shadowRoot;
    if (!root) return;
    root.querySelectorAll('klevu-button').forEach(injectButton);
    var layout = root.querySelector('klevu-chat-layout');
    var layoutRoot = layout && layout.shadowRoot;
    if (layoutRoot) layoutRoot.querySelectorAll('klevu-button').forEach(injectButton);
  }

  function scan() {
    document.querySelectorAll('klevu-product-query-popup').forEach(function (popup) {
      inject(popup);
      styleButtons(popup);
    });
    document.querySelectorAll('klevu-product-query').forEach(function (host) {
      var nested = host.shadowRoot && host.shadowRoot.querySelector('klevu-product-query-popup');
      if (!nested) return;
      inject(nested);
      styleButtons(nested);
    });
  }

  scan();
  document.addEventListener('DOMContentLoaded', scan);

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('klevu-product-query-popup').then(function () {
      scan();
      window.setTimeout(scan, 400);
      window.setTimeout(scan, 1500);
    });
  }

  var observer = new MutationObserver(scan);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(function () {
    observer.disconnect();
    scan();
  }, 8000);
})();
